// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__U-h-e"};